import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import { Box, IconButton } from "@mui/material";
import Iconify from "../../components/Iconify";
import Slider from "../../components/FixedSlider.js";

export default function AnimationTimelineSettings(props) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <IconButton
        size={props.iconSize}
        onClick={handleClick}
        sx={(theme) => ({ fontSize: props.iconFontSize ?? 20, ml: -1, mr: -1 })}
      >
        <Iconify icon="mdi:gear" />
      </IconButton>

      <Popover
        container={props?.containerRef?.current}
        PaperProps={{
          sx: {
            mb: 2,
          },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Box sx={{ p: 2, color: "white", backgroundColor: "rgba(0,0,0,0.8)" }}>
          <Box sx={{ fontWeight: 600, fontSize: 14, mb: 1 }}>
            Playback Speed
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Slider
              sx={{ color: "white" }}
              min={0.1}
              max={5}
              step={0.1}
              onChange={(x) => {
                props.setSpeed(x.target.value);
              }}
              value={props.speed}
              defaultValue={1}
            />

            {`${props.speed}x`}
          </Box>
        </Box>
      </Popover>
    </div>
  );
}
